import AvatarGroup from '@atlaskit/avatar-group';
import { observer } from 'mobx-react-lite';

interface Props {
  activity: any;
}

const MediaAssetListAvatar = ({ activity }: Props) => {
  const data = activity?.map((d: any) => ({
    email: d.displayName,
    key: d.appUserId,
    name: d.displayName,
    src: d.image,
    href: '#',
  }));

  return <AvatarGroup appearance="stack" data={data} />;
};

export default observer(MediaAssetListAvatar);
